import { useContext, useEffect, useRef, useState, useTransition } from "react";
import loaderContext from "../../../../../context/loader/LoaderContext";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import toastContext from "../../../../../context/toast/ToastContext";
import { useTranslation } from "react-i18next";
import {
  downloadDoc,
  fetchPeerReviewTimeLine,
  markEvaluationComplete,
  uploadEvaluationSheet,
  downloadSavedEvaluationSheet,
} from "../../../../../service/StudyListService";
import { TAB_NAME, TOAST_TYPE } from "../../../../../constants/Constants";
import ModalHeader from "../../../../../components/Modal/ModalHeader";
import ModalMain from "../../../../../components/Modal/ModalMain";
import PeerReviewTimelineBody from "./PeerReviewTimeLineBody";
import "./peerreview.css";
import userContext from "../../../../../context/users/UserContext";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import PeerReviewModalFooter from "./PeerReviewModalFooter";
import InfoIcon from "../../../../../components/SVGComponents/InfoIcon";
import DownloadFile from "../../../../../components/SVGComponents/DonwloadFile";
import ConfirmationModalFooter from "./ConfirmationModalFooter";

const PeerReviewModal = (props) => {
  const [timelineStatus, setTimelineStatus] = useState([]);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [data, setData] = useState();
  const [evaluationSheet, setEvaluationSheet] = useState();
  const [uploadedFileName, setUploadedFileName] = useState();
  const [primaryButtons, setPrimaryButtons] = useState([]);
  const { setAlertSuccessModal, alertSuccessModal } =
    useContext(studyReportContext);
  const { peerReviewAdmin, peerReviewEvaluator } = useContext(userContext);
  const [evaluationButtonState, setEvaluationButtonState] = useState(true);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const evaluationSheetPath = useRef();
  const [evaluationSheetOverride, setEvaluationSheetOverride] = useState(false);
  const [isFileSaved, setIsFileSaved] = useState();
  const [t] = useTranslation();

  const {
    setRefreshRequired,
    refreshRequired,
    dataQueryState,
    setDataQueryState,
  } = useContext(studylistContext);

  const hidePeerReviewModal = () => {
    props.setShowPeerReviewModal(false);
  };

  const handleFileUploadChange = async (fileList) => {
    if (!fileList || fileList.length === 0) return;
    const file = fileList[0];
    setEvaluationSheet(file);
    setIsFileSaved(true);
  };

  function extractFileName(evaluationSheetPath) {
    if (!evaluationSheetPath || typeof evaluationSheetPath !== "string") {
      return "";
    }
    const fileNameWithExtension = evaluationSheetPath.split("/").pop();
    const fileName = fileNameWithExtension.slice(
      fileNameWithExtension.indexOf("-") + 1
    );

    return fileName;
  }

  useEffect(() => {
    setPrimaryButtons(
      evaluationSheet ||
        (data?.assignmentId && data?.reviewStatus == 3 && peerReviewEvaluator)
        ? [
            {
              title: t("peer-review.button.mark-evaluation-complete"),
              onclick: () => handleComplete(data.assignmentId),
              disabled: isFileSaved,
              tooltip: t("peer-review.button.evalaution-complete"),
            },
          ]
        : []
    );
  }, [uploadedFileName, isFileSaved]);

  useEffect(() => {
    console.log("Evaluation Sheet Path", evaluationSheetPath);
  }, [evaluationSheetPath]);

  const fetchTimelines = async () => {
    setLoaderRunning(true);
    ref.current.continuousStart();

    try {
      const response = await fetchPeerReviewTimeLine(props.studyId);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        let data = response.data.data;
        setData(data);
        evaluationSheetPath.current = data?.evaluationSheetPath;
        data?.evaluationSheetPath
          ? setIsFileSaved(false)
          : setIsFileSaved(true);
        const constFileName = extractFileName(data.evaluationSheetPath);
        setUploadedFileName(constFileName);
        let timelineData = [
          {
            name: "Original Submission Date",
          },
          {
            name: "Peer Review Assigned",
          },
          {
            name: "Peer Review Submitted",
          },
          {
            name: "Evaluator Assigned",
          },
          {
            name: "Evalution Submitted",
          },
        ];
        console.log("timeline data", timelineData);
        setTimelineStatus(timelineData);
        setLoaderRunning(false);
        ref.current.complete();
      } else {
        setLoaderRunning(false);
        ref.current.complete();
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const downloadEvaluationSheet = async (event) => {
    event.preventDefault();
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await downloadDoc("Evaluationsheet");
      if (response.status === 200) {
        const decodedData = atob(response.data.data.byteArray);
        const arrayBuffer = new Uint8Array(decodedData.length);
        for (let i = 0; i < decodedData.length; i++) {
          arrayBuffer[i] = decodedData.charCodeAt(i);
        }
        const blob = new Blob([arrayBuffer], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = response.data.data.filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }
      setLoaderRunning(false);
      ref.current.complete();
    } catch (error) {
      setLoaderRunning(false);
      ref.current.complete();
      if (error.response.status === 403) return error.response;
    }
  };
  function _base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  const downloadSavedEvalualtionSheet = async (assignmentId, filePath) => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await downloadSavedEvaluationSheet(
        assignmentId,
        filePath
      );
      if (response?.data?.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
        const file = new Blob([fileData], { type: "application/pdf" });
        const url = window.URL.createObjectURL(file);
        window.open(url, "_blank", "width=600,height=700,location=no");
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
    }
  };

  const getPeerReviewGuideLines = async () => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      let res = await downloadDoc("Peerreviewguidelines");
      if (res?.data?.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        const fileData = _base64ToArrayBuffer(res.data.data.byteArray);
        const file = new Blob([fileData], { type: "application/pdf" });
        const url = window.URL.createObjectURL(file);
        window.open(url, "_blank", "width=600,height=700,location=no");
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
    }
  };

  const handleUpload = async () => {
    if (!evaluationSheet) {
      showToastv2(TOAST_TYPE.ERROR, t("peer-review.empty-file-upload"));
      return;
    }
    if (
      (data?.evaluationSheetPath &&
      evaluationSheet &&
      evaluationSheetOverride) || (evaluationSheet &&
      evaluationSheetOverride)
    ) {
      setConfirmationModal(true);
      return;
    } else if (evaluationSheet) {
      handleEvaluationSheetUpload();
    }
    else if (!evaluationSheetOverride) {
      showToastv2(TOAST_TYPE.ERROR, t("peer-review.empty-file-upload"));
      return;
    } 
  };

  const handleEvaluationSheetUpload = async () => {
     if(evaluationSheet?.size>0)
   {
     try {
      setLoaderRunning(true);
      ref.current.continuousStart();
      const response = await uploadEvaluationSheet(
        evaluationSheet,
        data.assignmentId
      );

      if (response.status == 200) {
        showToastv2(
          TOAST_TYPE.SUCCESS,
          t("peer-review.evaluation-sheet-uploaded")
        );
        setIsFileSaved(false);
        evaluationSheetPath.current = response.data?.data.result;
        setShowUploadModal(false);
      } else {
        showToastv2(TOAST_TYPE.ERROR, response?.message || "Upload failed.");
      }
    } catch (error) {
      console.error("Error uploading evaluation sheet:", error);
      showToastv2(
        TOAST_TYPE.ERROR,
        t("peer-review.evaluation-sheet-upload-error")
      );
    } finally {
      setLoaderRunning(false);
      ref.current.complete();
    }
      }else{
        showToastv2(
          TOAST_TYPE.ERROR,
          t("peer-review.empty-file-upload")
        );
      }
   }

  useEffect(() => {
    fetchTimelines();
  }, [props.studyId]);

  const handleComplete = async (assignmentId, fileName) => {
    try {
      console.log("Handle complete", uploadedFileName, data);
      if (uploadedFileName) {
        const response = await markEvaluationComplete(assignmentId,peerReviewEvaluator);
        setLoaderRunning(true);
        ref.current.continuousStart();
        if (response.status === 200) {
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = response.data?.data?.message;
            return newItem;
          });
          props.setShowPeerReviewModal(false);

          setTimeout(() => {
            setRefreshRequired(() => {
              const newItem = { ...refreshRequired };
              newItem[TAB_NAME.EVALUATIONASSIGNED].alreadyLoaded = false;
              console.log(newItem);
              return newItem;
            });
          }, 10);

          let newData = dataQueryState?.data?.rows.filter(
            (row) => row.id !== props.studyId
          );
          setDataQueryState(() => {
            const newValue = {
              ...dataQueryState,
            };
            newValue.data.rows = newData;
            return newValue;
          });
        } else {
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = response.data.message;
            return newItem;
          });
        }
      } else {
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = "Upload Peer Review Evaluation Sheet";
          return newItem;
        });
      }

      setLoaderRunning(false);
      ref.current.complete();
    } catch (error) {
      setLoaderRunning(false);
      ref.current.complete();
      if (error.response.status === 403) return error.response;
    }
  };

  let DefaultButtonList = [
    {
      title: t("button.close"),
      onclick: hidePeerReviewModal,
    },
  ];

  let SecondaryButtons = [
    {
      title: t("peer-review.button.donwload-guidelines"),
      onclick: getPeerReviewGuideLines,
      icon: <InfoIcon color={"#FFFFFF"} />,
      tooltip: t("peer-review.preview-guidelines"),
    },
    {
      title: t("peer-review.donwload-evaluatation-sheet"),
      onclick: downloadEvaluationSheet,
      icon: <DownloadFile />,
      tooltip: t("peer-review.download-evaluatation-sheet"),
    },
  ];

  const handleConfirmOverride = async () => {
    handleEvaluationSheetUpload();
    setEvaluationSheetOverride(false);
    setConfirmationModal(false);
  };

  const handleCloseConfirmationModal = () => {
    setIsFileSaved(false);
    fetchTimelines(); 
    setEvaluationSheet({});
    setEvaluationSheetOverride(false)
    setConfirmationModal(false);
  };

  const getSavedEvaluationSheet = async () => {
    if(evaluationSheetPath.current){
      downloadSavedEvalualtionSheet(
        data?.assignmentId,
        evaluationSheetPath.current
      );
    }else{
      showToastv2(
        TOAST_TYPE.ERROR,
        t("peer-review.save-files")
      );  
    }
   
  };
  let confirmationButtonsList = [
    {
      title: t("button.yes"),
      onclick: handleConfirmOverride,
    },
    {
      title: t("button.no"),
      onclick: handleCloseConfirmationModal,
    },
  ];

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={t("peer-review.title")}
        handleCancel={hidePeerReviewModal}
      />
    ),
    body: (
      <PeerReviewTimelineBody
        data={data}
        timelineStatus={timelineStatus}
        downloadEvaluationSheet={downloadEvaluationSheet}
        getPeerReviewGuideLines={getPeerReviewGuideLines}
        handleFileUploadChange={handleFileUploadChange}
        isFileSaved={setIsFileSaved}
        saveEvaluationSheet={setEvaluationSheet}
        getEvaluationSheet={evaluationSheet}
        handleUpload={handleUpload}
        uploadFileName={setUploadedFileName}
        fileName={uploadedFileName}
        markEvaluationButtonState={setEvaluationButtonState}
        downloadSavedEvalualtionSheet={downloadSavedEvalualtionSheet}
        evaluationSheetPath={evaluationSheetPath}
        getSavedEvaluationSheet={getSavedEvaluationSheet}
        extractFileName={extractFileName}
        setEvaluationSheetOverride={setEvaluationSheetOverride}
        evaluationSheetOverride={evaluationSheetOverride}
        
      />
    ),
    footer: (
      <PeerReviewModalFooter
        DefaultButtonList={DefaultButtonList}
        PrimaryButtonList={primaryButtons}
        SecondaryButtonList={(data?.reviewStatus === 3 && peerReviewEvaluator) ? SecondaryButtons : [SecondaryButtons[0]]}
      />
    ),
    width: "785px",
  };
  const confirmationModalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={t("user.alert")}
        handleCancel={handleCloseConfirmationModal}
      />
    ),
    body: (
      <div style={{padding: "2%",fontWeight:"600"}}>
        {t("peer-review.override-uploaded-evalaution-sheet")}
      </div>
    ),
    footer: <ConfirmationModalFooter PrimaryButtonList={[confirmationButtonsList[0]]} SecondaryButtonList={[confirmationButtonsList[1]]} />,
    width: "500px",
  };

  return (
    <>
      {props.showPeerReviewModal && (
        <ModalMain
          showModal={props.showPeerReviewModal}
          modalDetails={modalDetails}
        />
      )}
      {confirmationModal && (
        <ModalMain
          showModal={confirmationModal}
          modalDetails={confirmationModalDetails}
        />
      )}
    </>
  );
};

export default PeerReviewModal;
